// react
import { useContext } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextProject } from '../../Project.context';

// mui
import { Container, Grid, Paper, Typography } from '@mui/material';

// forms
import { FormEditProject } from '../../../../forms/FormEditProject/FormEditProject';

export const Project = () => {
	// hooks
	const { t } = useTranslation();

	// context
	const { project } = useContext(ContextProject);

	if (!project) {
		return null;
	}

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper sx={{ p: 3 }}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h3">{t('project')}</Typography>
							</Grid>
							<Grid item xs={12}>
								<FormEditProject />
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
		</Container>
	);
};
